import { createContext } from "react";

const TeacherContext = createContext();

export default TeacherContext;